import axios from 'axios';

const API_URL = `${process.env.REACT_APP_BACKEND_URL}/api`;

const rid = () => Math.random().toString(36).slice(2) + Date.now().toString(36);

export const getAnonId = () => {
  let a = localStorage.getItem('cc_anon_id');
  if (!a) { a = rid(); localStorage.setItem('cc_anon_id', a); }
  return a;
};

export const getSessionId = () => {
  const now = Date.now();
  const last = parseInt(sessionStorage.getItem('cc_sess_ts') || '0', 10);
  let s = sessionStorage.getItem('cc_sess_id');
  if (!s || now - last > 30 * 60 * 1000) {
    s = rid();
    sessionStorage.setItem('cc_sess_id', s);
  }
  sessionStorage.setItem('cc_sess_ts', String(now));
  return s;
};

const detectSource = () => {
  const p = new URLSearchParams(window.location.search);
  const utm = p.get('utm_source');
  if (utm) return utm.toLowerCase();
  const ref = document.referrer;
  if (!ref) return 'direct';
  try {
    const h = new URL(ref).hostname;
    if (h.includes(window.location.hostname)) return null; // navigation interne
    if (h.includes('google')) return 'google';
    if (h.includes('facebook')) return 'facebook';
    if (h.includes('instagram')) return 'instagram';
    if (h.includes('tiktok')) return 'tiktok';
    if (h.includes('linkedin')) return 'linkedin';
    return 'referral';
  } catch { return 'direct'; }
};

const touchSources = () => {
  const src = detectSource();
  if (src) {
    if (!localStorage.getItem('cc_src_first')) localStorage.setItem('cc_src_first', src);
    localStorage.setItem('cc_src_last', src);
  }
  return {
    source_first: localStorage.getItem('cc_src_first') || 'direct',
    source_last: localStorage.getItem('cc_src_last') || 'direct',
  };
};

export const getPlatform = () => window.Capacitor?.getPlatform?.() || 'web';

export const track = (event, props = {}) => {
  try {
    const { source_first, source_last } = touchSources();
    axios.post(`${API_URL}/track`, {
      event,
      event_id: rid(),
      anon_id: getAnonId(),
      session_id: getSessionId(),
      lang: localStorage.getItem('cc_lang') || 'fr',
      platform: getPlatform(),
      source_first,
      source_last,
      props,
    }).catch(() => {});
  } catch { /* le tracking ne doit jamais casser l'app */ }
};

export const trackOncePerSession = (event, props = {}) => {
  const key = `cc_trk_${event}`;
  if (sessionStorage.getItem(key)) return;
  sessionStorage.setItem(key, '1');
  track(event, props);
};
